import React from 'react';
import { IconWrapper, Root } from './styles';
import { cx } from '@linaria/core';
import Icon from '../../Icon/Icon';
function SwiperButton({ direction = 'right', isVisible = false, role = 'button', swiperId }) {
    /** Variables */
    const dir = direction === 'right' ? 'next' : 'prev';
    const genericClassName = `swiper-button-${dir}`;
    let className = genericClassName;
    if (swiperId) {
        const uniqueClassName = `swiper-${swiperId ? swiperId + '-' : '-'}button-${dir}`;
        className += ' ' + uniqueClassName;
    }
    /** JSX */
    return (React.createElement("div", { className: cx(Root.base, isVisible && Root.isVisible, Root.direction[direction], className), role: role },
        React.createElement("div", { className: cx(IconWrapper.base) },
            React.createElement(Icon, { name: "chevronLeft" }))));
}
export default SwiperButton;
